import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonImg, IonAlert, IonIcon, IonButton, IonGrid, IonRow, IonCol, IonItem } from '@ionic/react';
import { useParams } from 'react-router-dom';
import InnerMenu from '../components/InnerMenu';
import { useLocation } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import { Storage } from '@ionic/storage';
import { locationOutline } from 'ionicons/icons'
import {localStore, deviceId} from '../App';
import PageEventHandler from "../components/PageEventHandler"
import GpsSinglePointComponent from '../components/GpsSinglePointComponent';
import './Dock.css';
import JsonRoutes from "../json_routes/pavia-voltagrimana.json";
import {lookAtDistance} from "../js/dockDistanceCalculator.js";
import { BASE_URL } from '../utils/constant';
import { LanguageContext } from '../contexts/LanguageContext';
import { dockTranslations } from '../translations/dock';
import { dockTypes } from '../translations/dockTypes';
import NotificationRedirect from '../components/NotificationRedirect';

const Dock: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = dockTranslations[language];
  
  const { id } = useParams<{ id: string; }>();
  const [thisDock, setThisDock] = useState<any | null>(null);
  const [loadingText, setLoadingText] = useState(t.loading);
  const [showAlert2, setShowAlert2] = useState(false);
  const [thisDockDistance, setThisDockDistance] = useState(t.calculating);
  const [userCoords, setUserCoords] = useState<any|null>(null);

  // Update loading text when language changes
  useEffect(() => {
    setLoadingText(t.loading);
  }, [language]);

  async function getThisDockFromList() {
    
    await localStore.get("dockslist")
      .then(
        (docks) => {
          if (docks != null) {
            setThisDock(docks[id]);
          } else {
            console.log(t.noDocksMemory);
            setLoadingText(t.noDocksMemory);
            fetchRemoteDocks().then(remoteDocks => {
              setThisDock(docks[id]);
            });
          }
        },
        (error) => {
          console.log(t.docksError, error);
        }
      );
  }

  async function fetchRemoteDocks()
  {
    return new Promise(function(resolve,reject)
    {
      // load docks from server
      const url = `${BASE_URL}/poServer.php?act=1&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            // setDocksList(result.content);
            localStore.set('dockslist', result.content);
            resolve(result.content);
          },
          (error) => {
            console.log('Problema nella ricezione dei dati sugli attracchi: ',error);
            setLoadingText('Problema nella ricezione dei dati sugli attracchi - riavviare l\'app e  riprovare');
            setShowAlert2(true);
            resolve(null);
          }
      );
    });
  }

  useEffect(() => {
    getThisDockFromList();
    setThisDockDistance(lookAtDistance(thisDock, userCoords));
  }, [thisDock, userCoords, id]);

  return (
    <IonPage>
      <IonHeader>
        <InnerMenu name={t.pageTitle} />
      </IonHeader>
      <IonContent fullscreen>
        {/* while loading */}
        {thisDock == null &&
          <div>{loadingText}</div>
        }
        {/* if loading went fine */}
        {thisDock != null &&
          <div>
            <IonItem lines="none">
              <h1 className="mainTit" slot="start">{thisDock.name}</h1>
            </IonItem>
            <IonGrid className="ion-padding">
              <IonRow>
                <IonCol size="10">
                  <h2>{thisDock.village}, {thisDock.postcode} {thisDock.city}</h2>
                </IonCol>
                <IonCol size="2">
                  <IonButton routerLink={`/docksMap/dock/${id}`} fill="clear" size="large" className="ion-no-padding">
                    <IonIcon icon={locationOutline} className="dockButton"></IonIcon>
                  </IonButton>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="4" className="colTit">{t.currentDistance}</IonCol>
                <IonCol>{thisDockDistance}</IonCol>
              </IonRow>
              {thisDock.phone_fixed != '' &&
                <IonRow>
                  <IonCol size="4" className="colTit">{t.landlinePhone}</IonCol>
                  <IonCol><a href={`tel:${thisDock.phone_fixed}`}>{thisDock.phone_fixed}</a></IonCol>
                </IonRow>
              }
              {thisDock.phone_mobile != '' &&
                <IonRow>
                  <IonCol size="4" className="colTit">{t.mobilePhone}</IonCol>
                  <IonCol><a href={`tel:${thisDock.phone_mobile}`}>{thisDock.phone_mobile}</a></IonCol>
                </IonRow>
              }
              <IonRow>
                <IonCol size="4" className="colTit">{t.boatSpaces}</IonCol>
                <IonCol>{thisDock.boat_spaces}</IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="4" className="colTit">{t.dockType}</IonCol>
                <IonCol>
                  {thisDock.dockTypes.map((element:any, index:any) => {
                    return (
                      <span key={index}>
                        {language === 'en' 
                          ? dockTypes['en'][dockTypes['it'].indexOf(element.name)]
                          : element.name
                        }<br />
                      </span>
                    )
                  })}
                </IonCol>
              </IonRow>
              {thisDock.services_public != '' &&
                <IonRow>
                  <IonCol size="4" className="colTit">{t.publicServices}</IonCol>
                  <IonCol>{language === 'en' && thisDock.services_public_en ? thisDock.services_public_en : thisDock.services_public}</IonCol>
                </IonRow>
              }
              {thisDock.services_members != '' &&
                <IonRow>
                  <IonCol size="4" className="colTit">{t.memberServices}</IonCol>
                  <IonCol>{language === 'en' && thisDock.services_members_en ? thisDock.services_members_en : thisDock.services_members}</IonCol>
                </IonRow>
              }
              {thisDock.description != '' &&
                <IonRow>
                  <IonCol size="4" className="colTit">{t.description}</IonCol>
                  <IonCol>{language === 'en' && thisDock.description_en ? thisDock.description_en : thisDock.description}</IonCol>
                </IonRow>
              }
              {thisDock.restaurants != '' &&
                <IonRow>
                  <IonCol size="4" className="colTit">{t.restaurants}</IonCol>
                  <IonCol>{thisDock.restaurants}</IonCol>
                </IonRow>
              }
              {thisDock.hotels != '' &&
                <IonRow>
                  <IonCol size="4" className="colTit">{t.hotels}</IonCol>
                  <IonCol>{thisDock.hotels}</IonCol>
                </IonRow>
              }
              {thisDock.picture &&
                <IonRow>
                  <IonCol size="12" className="colTit">
                    <IonImg src={`https://www.portolanodelpo.it/poServer/docks_img/${thisDock.picture}`} />
                  </IonCol>
                </IonRow>
              }
            </IonGrid>
          </div>
        }
      </IonContent>
      <IonAlert
        header={t.errorHeader}
        isOpen={showAlert2}
        message={t.errorMessage}
        buttons={[{ text: t.okButton }]}
        onDidDismiss={() => setShowAlert2(false)}
      />
      <PageEventHandler pageIndex={3} dockIndex={thisDock ? Number(thisDock.id) : 0}/>
      <GpsSinglePointComponent setUserCoords={setUserCoords}/>
      <NotificationRedirect /> {/* redirect to the page specified in the local storage */}
    </IonPage>
  );
};

export default Dock;
